import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import { useLazyGetTransactionLogsQuery } from '../../../store/statuses/services';

const TransactionFeeLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const {
    transactionFee: { transaction },

    statuses: { statusLogs },
  } = useAppSelector((state) => state);

  const [getLogsTransaction, { isLoading }] = useLazyGetTransactionLogsQuery();

  const getLogsTransactionAction = useCallback(() => {
    getLogsTransaction({ id: transactionId as string, url: 'internal' });
  }, [transactionId, transaction]);

  useEffect(() => {
    if (!statusLogs && transactionId) {
      getLogsTransactionAction();
    }
  }, [getLogsTransactionAction, statusLogs, transactionId]);

  return <TransactionLogsContent isLoading={isLoading} logs={statusLogs} />;
};

export default TransactionFeeLogContentHOC;
